import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import showDisabled from '../../assets/images/show-disabled.svg';
import show from '../../assets/images/show-idle.svg';
import hideDisabled from '../../assets/images/hide-disable.svg';
import hide from '../../assets/images/hide-idle.svg';
import './style.scss';

@observer
class FormInput extends Component {
    @observable type = this.props.type;

    handleInputChange = (e) => {
        let {value} = e.target;
        if (this.props.filterCharacters) {
            value = this.props.filterCharacters(e.target.value, this.props.value);
        }
        if (this.type === 'checkbox') {
            value = e.target.checked;
        }
        this.props.onChange(e.target.name, value, e.currentTarget);
    };

    handleInputBlur = (e) => {
        if (this.props.onBlur) this.props.onBlur(e.target.name, e.target.value, e.currentTarget);
    };

    @action toggleShowPassword = () => {
        this.type = this.type === 'text' ? 'password' : 'text';
    };

    renderIcon = () => {
        if (this.type === 'text' && this.props.disabled) {
            return hideDisabled;
        } else if (this.type === 'text') {
            return hide;
        } else if (this.type !== 'text' && this.props.disabled) {
            return showDisabled;
        }
        return show;
    };

    render() {
        const {
            name,
            placeholder = '',
            value,
            error,
            disabled,
            disabledInner,
            maxLength,
            type,
            pattern = null,
            inputClass = '',
            inputPlaceholder = '',
            className = '',
            readOnly = false,
            tooglePass = false,
            autoFocus = false,
            renderExtraIcon = false,
            onClickExtraIcon = null,
            required,
            fieldStyle = {},
            onKeyUp = () => {}
        } = this.props;

        return (
            <div className={`a-form-box ${error ? 'has-error' : ''} ${disabled ? 'disabled' : ''} ${className}`}>
                <div className="a-form-top">
                    <div className="a-form-label">{placeholder} {required && <span className="required">*</span>}</div>
                    <div className="a-form-error">{error}</div>
                    {type === 'password' && tooglePass && <div className='a-from-show-hide-password' onClick={this.toggleShowPassword}>
                        <img src={this.renderIcon()} alt="" />
                    </div>}
                    {renderExtraIcon && <div className={`a-from-extra-icon ${onClickExtraIcon ? 'click' : ''}`} onClick={onClickExtraIcon}>
                        {renderExtraIcon}
                    </div>}
                </div>
                {(type.toLowerCase() === 'textarea') ?
                    <textarea className={`a-form-input ${inputClass}`} name={name} value={value}
                        onChange={this.handleInputChange} onBlur={this.handleInputBlur} placeholder={inputPlaceholder} />
                    :
                    <input className={`a-form-input ${inputClass} ${disabledInner ? 'disabled' : ''}`} type={this.type} name={name} value={value}
                        autoFocus={autoFocus} onChange={this.handleInputChange} onBlur={this.handleInputBlur}
                        onKeyUp={onKeyUp} placeholder={inputPlaceholder} maxLength={maxLength || null}
                        pattern={pattern} readOnly={readOnly} style={fieldStyle} />
                }
            </div>
        );
    }
}

export default FormInput;
